import React from "react";
import { Box, List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import { Link } from "react-router-dom"; // Use Link for navigation
import DashboardIcon from "@mui/icons-material/Dashboard";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { useUser } from "../contexts/UserContext";

const Sidebar = () => {
	const { userRole } = useUser(); // Get the user role from the context

	return (
		<Box
			sx={{
				width: "220px",
				height: "100vh",
				position: "fixed",
				top: 0,
				left: 0,
				backgroundColor: "#2c2d2d", // Jet black background
				boxShadow: 2,
				paddingTop: "64px",
				zIndex: 1000,
				fontFamily: "Roboto, sans-serif", // Applying Roboto font directly here
			}}
		>
			<List>
				{userRole !== "admin" && (
					<>
						<ListItem button component={Link} to="/dashboard">
							<ListItemIcon>
								<DashboardIcon sx={{ color: "#fff" }} />
							</ListItemIcon>
							<ListItemText
								primary="Dashboard"
								sx={{
									color: "#fff",
									fontFamily: "Roboto, sans-serif", // Roboto font for text
								}}
							/>
						</ListItem>
						<ListItem button component={Link} to="/plan-management">
							<ListItemIcon>
								<LibraryBooksIcon sx={{ color: "#fff" }} />
							</ListItemIcon>
							<ListItemText
								primary="Plan Management"
								sx={{
									color: "#fff",
									fontFamily: "Roboto, sans-serif", // Roboto font for text
								}}
							/>
						</ListItem>
						<ListItem button component={Link} to="/transactions">
							<ListItemIcon>
								<AccountBalanceIcon sx={{ color: "#fff" }} />
							</ListItemIcon>
							<ListItemText
								primary="Transactions"
								sx={{
									color: "#fff",
									fontFamily: "Roboto, sans-serif", // Roboto font for text
								}}
							/>
						</ListItem>
					</>
				)}
			</List>
		</Box>
	);
};

export default Sidebar;
